import { connect } from 'react-redux';

import type { NextOrPreviousPayload } from 'src/components/organisms/ProductImagesCarousel/types';
import type {
  ProductImagesModalDispatchProps,
  ProductImagesModalStateProps,
} from 'src/components/organisms/ProductImagesModal/ProductImagesModal';
import { ProductImagesModal } from 'src/components/organisms/ProductImagesModal/ProductImagesModal';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProductMedia } from 'src/redux/product/selectors';
import { actions } from 'src/redux/productImagesCarousel/slice';
import type { AppThunkDispatch } from 'src/redux/store';

const mapStateToProps = (state: ReduxApplicationState): ProductImagesModalStateProps => {
  return {
    currentImage: state.productImagesCarousel.currentImage,
    media: selectProductMedia(state),
    isModalOpen: state.productImagesCarousel.isModalOpen,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductImagesModalDispatchProps => {
  return {
    closeModal: () => dispatch(actions.closeModal()),
    onNextImage: (payload: NextOrPreviousPayload) => dispatch(actions.nextImage(payload)),
    onPrevImage: (payload: NextOrPreviousPayload) => dispatch(actions.prevImage(payload)),
  };
};

export const ProductImagesModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductImagesModal);
